module.exports = __webpack_public_path__ + "static/media/navbar-arrow-down.96e756a9.svg";